module.exports = __webpack_public_path__ + "assets/feature5-c4837353a24413fdaeddf05451dd41d8.svg";